import { render, staticRenderFns } from "./Parceiros.vue?vue&type=template&id=5637e6ac&scoped=true&"
var script = {}
import style0 from "./Parceiros.vue?vue&type=style&index=0&id=5637e6ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637e6ac",
  null
  
)

export default component.exports